import * as React from 'react';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import { DocumentEditorContainerComponent, Toolbar, CollaborativeEditingHandler, ContainerContentChangeEventArgs, Operation, Inject } from '@syncfusion/ej2-react-documenteditor';
import { DocumentEditor } from '@syncfusion/ej2-react-documenteditor';
import { TitleBar } from './title-bar';
import { HubConnectionBuilder, HttpTransportType, HubConnectionState, HubConnection } from '@microsoft/signalr';
import { createSpinner, hideSpinner, showSpinner } from '@syncfusion/ej2-popups';
import { IDocumentLoader, saveDocument2Contentum, IDocumentWoutBody } from './types/document';
import { ToastComponent , ToastUtility, Toast } from '@syncfusion/ej2-react-notifications';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { ActionInfo } from '@syncfusion/ej2-documenteditor';
import AboutDocumentDialog from './about';
import moment from 'moment';
import { L10n } from '@syncfusion/ej2-base';
import wordLocale from './locale/word.locale.json';

const users : string[] = ['Лена', 'Сергійко', 'Галя', 'Петро'];
    
interface WordAppProps {
    enableRTL: boolean;
    documentLoader: IDocumentLoader;
    roomName: string | null;
    version: number;
}

// tslint:disable:max-line-length
class CollaborateWordApp extends React.Component <WordAppProps, { collaborateUsers: string }> {
    public serviceUrl = 'https://document.e-contentum.com/signalr/';//'http://192.168.1.127:5212/';
    public container!: DocumentEditorContainerComponent | null;
    public titleBar?: TitleBar;
    public collaborativeEditingHandler?: CollaborativeEditingHandler;
    public connectionId: string = '';
    public connection?: HubConnection;

    public currentUser: any = this.props.documentLoader.user.name; 
    public currentRoomName: string = '';

    public toastInstance: ToastComponent = null!;

    constructor(props: WordAppProps) {
        super(props);
        this.state = {
            collaborateUsers: '<p>Online:</p><ul><li>' + props.documentLoader.user.name + '</li></ul>'
        };
        L10n.load(wordLocale);
    }

    public toastCreated(): void {
        if (!this.toastInstance) return ;
        if (this.props.documentLoader.document.metadata.isBlocked || !this.props.documentLoader.document.access.allowEdit)
            this.toastInstance.show();
    }

    public onCreated(): void {

        if (!this.container) return ; // serhii
        const editor : DocumentEditor = this.container.documentEditor;
        this.collaborativeEditingHandler = this.container.documentEditor.collaborativeEditingHandlerModule;
        
        //this.container.restrictEditing = false;
        this.container.documentEditor.isReadOnly = !this.props.documentLoader.document.access.allowEdit;

        // true - автоматически включает Track Changes, false - можно отключить пользователю
        if (this.props.documentLoader.document.access.allowEdit) {
            this.container.documentEditor.enableTrackChanges = true;
            this.container.documentEditor.showRevisions = true;
        }

        const self = this;
        this.container.contentChange = (args: ContainerContentChangeEventArgs) => {
            if (this.collaborativeEditingHandler) {
                //Send the editing action to server
                self.container!.documentEditor.enableTrackChanges = true;
                self.container!.documentEditor.showRevisions = true;
                this.collaborativeEditingHandler.sendActionToServer(args.operations as Operation[])
            }
        }
        if (!this.connection) {
            this.initializeSignalR();
            this.loadDocumentFromServer();
        }
        //this.titleBar?.updateDocumentTitle();
    }

    public componentDidMount(): void {
        //window.onbeforeunload = function () {
        //    return 'Want to save your changes?';
        //}
        if (this.container) {           
            this.container.documentEditor.pageOutline = '#E0E0E0';
            this.container.documentEditor.acceptTab = true;
            this.container.documentEditor.resize();
            this.titleBar = new TitleBar(document.getElementById('documenteditor_titlebar') as HTMLElement, document.getElementById('documenteditor_titlebar_badge') as HTMLElement);
            //Inject the collaborative editing handler to DocumentEditor
            DocumentEditor.Inject(CollaborativeEditingHandler);
            //Enable the collaborative editing in DocumentEditor
            this.container.documentEditor.enableCollaborativeEditing = true;
        }
    }

    public initializeSignalR = (): void => {
        // SignalR connection
        this.connection = new HubConnectionBuilder().withUrl(this.serviceUrl + 'documenteditorhub', {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets
        }).withAutomaticReconnect().build();
        //Event handler for signalR connection
        this.connection.on('dataReceived', this.onDataRecived.bind(this));

        this.connection.onclose(async () => {
            if (this.connection && this.connection.state === HubConnectionState.Disconnected) {
                alert('Connection lost. Please relod the browser to continue.');
            }
        });
        this.connection.onreconnected(() => {
            if (this.connection && this.currentRoomName != null) {
                this.connection.send('JoinGroup', { roomName: this.currentRoomName, currentUser: this.currentUser });
            }
        });
    }

    public onDataRecived(action: string, data: any) {
        if (this.collaborativeEditingHandler) {
            if (action == 'connectionId') {
                //Update the current connection id to track other users
                this.connectionId = data;
            } else if (this.connectionId != data.connectionId) {
                if (this.titleBar) {
                    if (action == 'action' || action == 'addUser') {
                        //Add the user to title bar when user joins the room
                        this.titleBar.addUser(data);
                        this.createCollaborationUserList(data);
                    } else if (action == 'removeUser') {
                        //Remove the user from title bar when user leaves the room
                        this.titleBar.removeUser(data);
                        this.createCollaborationUserList(data);
                    }
                }
            }
            //Apply the remote action in DocumentEditor
            this.collaborativeEditingHandler.applyRemoteAction(action, data);
        }
    }

    //public openDocument(responseText: string, roomName: string): void {
    public openDocument(documentLoader: IDocumentLoader, roomName: string): void {

        //let data = JSON.parse(responseText);
        if (this.container) {
            //Update the room and version information to collaborative editing handler.
            this.collaborativeEditingHandler?.updateRoomInfo(roomName, this.props.version, this.serviceUrl + 'CollaborativeEditing/');

            //Open the document
            this.container.documentEditor.open(documentLoader.document.body);

            if (this.props.documentLoader.document.metadata.isBlocked || !this.props.documentLoader.document.access.allowEdit)
                this.toastInstance.show();

            setTimeout(() => {
                if (this.container) {
                    // connect to server using signalR
                    this.connectToRoom({ action: 'connect', roomName: roomName, currentUser: this.container.currentUser });
                }
            });
        }


        hideSpinner(document.body);
    }

    public loadDocumentFromServer() {
        createSpinner({ target: document.body });
        showSpinner(document.body);

        if (this.props.roomName && this.props.documentLoader) {
            this.openDocument(this.props.documentLoader, this.props.roomName);
            hideSpinner(document.body);
        }
        else {
            hideSpinner(document.body);
            alert('Fail to load the document');
        }
    }

    public connectToRoom(data: any) {
        try {
            this.currentRoomName = data.roomName;
            if (this.connection) {
                // start the connection.
                this.connection.start().then(() => {
                    // Join the room.
                    if (this.connection) {
                        this.connection.send('JoinGroup', { roomName: data.roomName, currentUser: data.currentUser });
                    }
                });
            }

        } catch (err) {
            //Attempting to reconnect in 5 seconds
            setTimeout(this.connectToRoom, 5000);
        }
    };

    public onChangeLanguage(changeLanguage: any, args: any) : void {
        changeLanguage(args.item.properties.id);
    }

    createCollaborationUserList(actionInfos: ActionInfo | ActionInfo[]) : void {
        if (!(actionInfos instanceof Array)) {
            actionInfos = [actionInfos]
        }

        const userList : string[] = [];
        let result : string = '';
        userList.push(this.props.documentLoader.user.name);
        result = result + '<p>Online:</p><ul><li>' + this.props.documentLoader.user.name + '</li>';
        for (let i: number = 0; i < actionInfos.length; i++) {
            let actionInfo: ActionInfo = actionInfos[i];
            if (!userList.find((item: string) => item === actionInfo.currentUser as string)) {
                userList.push(actionInfo.currentUser as string);
                result = result + '<li>' + actionInfo.currentUser as string + '</li>';
            }
        }
        this.setState({collaborateUsers: result + '</ul>'});
    }

    public getAutorName(authorName: string) : string {
        const splittedName: string[] = authorName.split(' ');
        let initials: string = '';
        for (let i: number = 0; i < splittedName.length; i++) {
            if (splittedName[i].length > 0 && splittedName[i] !== '') {
                initials += splittedName[i][0];
            }
        }
        return initials;
    }

    public getDocumentAccessInfo() : string {
        if (this.props.documentLoader.document.metadata.isBlocked) {
            return 'Редагування недоступне, оскільки версію документа заблоковано користувачем';
        }
        if (!this.props.documentLoader.document.access.allowEdit) {
            return 'Редагування недоступне, оскільки у вас відсутні права на редагування';
        }
        return '';
    }

    render() {
        return (
            <React.Fragment>
                <div className="row" style={{ maxHeight: '40px' }}>
                    <div className="col-md-12">
                        <TooltipComponent position="TopCenter" content="Tooltip Content" target="#element">
                            <AppBarComponent mode="Dense" colorMode="Primary" id='documenteditor_titlebar'>
                                <AboutDocumentDialog documentLoader={this.props.documentLoader}/>
                                <span className="dense">Contentum: {this.props.documentLoader.document.name}</span>
                                <div className="e-appbar-spacer"></div>
                                <span className="e-avatar e-avatar-xsmall e-avatar-circle" 
                                    title={this.props.documentLoader.user.name}
                                    style={{ backgroundColor: "violet", marginTop: "3px", marginRight: "5px" }}>{this.getAutorName(this.props.documentLoader.user.name)}
                                </span>
                            </AppBarComponent>
                        </TooltipComponent>
                    </div>
                </div>
                <div id='documenteditor_titlebar' className="e-de-ctn-title" style={{ height: "25px", textAlign: this.props.enableRTL ? "right" : "center" }}>
                    {!this.props.documentLoader.document.metadata.isBlocked && this.props.documentLoader.document.access.allowEdit && 
                        <TooltipComponent position="TopCenter" content={this.state.collaborateUsers} target="#collaborate_title">
                            <div id="collaborate_title" style={{ width: '100%', height: '100%', paddingTop: '5px' }}>
                                <span style={{ color: "lightgrey" }}>{'РЕЖИМ СУМІСНОГО РЕДАГУВАННЯ'}</span>
                                <span id='documenteditor_titlebar_badge' className="e-badge e-badge-success" style={{ marginLeft: "5px" }}></span>
                            </div>
                        </TooltipComponent>
                    }
                    <span style={{ color: "#fd706b" }}>{this.getDocumentAccessInfo()}</span>
                </div>
                <div id="editorContainerElement">
                    <DocumentEditorContainerComponent 
                        id="container" 
                        created={this.onCreated.bind(this)} 
                        ref={(scope: any) => { this.container = scope; }} 
                        style={{ display: "block" }}
                        width={window.innerWidth + 'px'}
                        height={window.innerHeight - 70 + 'px'}
                        currentUser={this.currentUser} 
                        serviceUrl={this.serviceUrl + 'documenteditor'} 
                        enableToolbar={true} 
                        locale="uk-UA"
                        autoResizeOnVisibilityChange={true}
                        showPropertiesPane={ !this.props.documentLoader.document.access.allowEdit ? false : true } // if readonly - false, else true or false
                        enableRtl={this.props.enableRTL}
                        toolbarItems={
                            !this.props.documentLoader.document.access.allowEdit ? 
                            [
                            //'New','Open',
                            'Separator','Undo','Redo',
                            'Separator','Image','Table','Hyperlink','Bookmark','TableOfContents',
                            'Separator','Header','Footer','PageSetup','PageNumber','Break','InsertFootnote','InsertEndnote',
                            'Separator','Find',
                            'Separator','Comments',
                            //'TrackChanges',
                            'LocalClipboard',
                            //'RestrictEditing',
                            'Separator','FormFields','UpdateFields','ContentControl'
                            ] : [
                            //'New','Open',
                            'Separator','Undo','Redo',
                            'Separator','Image','Table','Hyperlink','Bookmark','TableOfContents',
                            'Separator','Header','Footer','PageSetup','PageNumber','Break','InsertFootnote','InsertEndnote',
                            'Separator','Find',
                            'Separator','Comments',
                            //'TrackChanges',
                            'LocalClipboard',
                            'RestrictEditing',
                            'Separator','FormFields','UpdateFields','ContentControl'
                            ]
                        }
                    >
                        <Inject services={[Toolbar]} />
                    </DocumentEditorContainerComponent>
                </div>
                <ToastComponent 
                    ref={(toast: any) => this.toastInstance = toast!} 
                    title="На жаль, Ви не можете редагувати документ"
                    content={
                        this.props.documentLoader.document.metadata.isBlocked ?
                            "Цю версію документа було заблоковано користувачем" + ' ' + moment(new Date(this.props.documentLoader.document.metadata.blockedDate)).format('DD.MM.YYYY HH:mm')
                        :
                            !this.props.documentLoader.document.access.allowEdit && 
                                'У вас відсутні права на редагування документа. Зверніться будь ласка до автора документа або до адміністратора системи Contentum'
                    }
                    created={this.toastCreated} 
                    showProgressBar={true}
                    timeOut={10000}
                    position={{ X: 'Right', Y: 'Top' }}
                    enableRtl={this.props.enableRTL}
                />
                <div className="toastUtility"></div>
            </React.Fragment>
        );
    }

}
export default CollaborateWordApp;

